export default [
    {
        path: "/hubby/country-package-size",
        props: true,
        component: () => import("@/views/Hubby/CountryPackageSize"),
    },
];
